var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurplePaperIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 40,
    viewBox: "0 0 35 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3515 28.78H22.1238C22.9356 28.78 23.6089 28.1 23.6089 27.28C23.6089 26.46 22.9356 25.8 22.1238 25.8H11.3515C10.5396 25.8 9.86634 26.46 9.86634 27.28C9.86634 28.1 10.5396 28.78 11.3515 28.78ZM18.0446 15.8H11.3515C10.5396 15.8 9.86634 16.48 9.86634 17.3C9.86634 18.12 10.5396 18.78 11.3515 18.78H18.0446C18.8564 18.78 19.5297 18.12 19.5297 17.3C19.5297 16.48 18.8564 15.8 18.0446 15.8ZM32.1761 14.0512C32.6416 14.0458 33.1484 14.04 33.6089 14.04C34.104 14.04 34.5 14.44 34.5 14.94V31.02C34.5 35.98 30.5198 40 25.6089 40H9.84653C4.69802 40 0.5 35.78 0.5 30.58V9.02C0.5 4.06 4.5 0 9.43069 0H20.0049C20.5198 0 20.9158 0.42 20.9158 0.92V7.36C20.9158 11.02 23.9059 14.02 27.5297 14.04C28.3761 14.04 29.1224 14.0463 29.7754 14.0519C30.2834 14.0562 30.7351 14.06 31.1337 14.06C31.4155 14.06 31.7809 14.0558 32.1761 14.0512ZM32.7222 11.132C31.0945 11.138 29.1756 11.132 27.7954 11.118C25.6053 11.118 23.8014 9.296 23.8014 7.084V1.812C23.8014 0.95 24.837 0.522 25.4291 1.144C26.5001 2.26877 27.9717 3.81463 29.4368 5.35368C30.8999 6.89061 32.3566 8.42076 33.4014 9.518C33.9796 10.124 33.5558 11.13 32.7222 11.132Z",
    fill: "url(#paint0_linear_157_3240)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_157_3240",
    x1: 34.5,
    y1: 40,
    x2: -6.8467,
    y2: 29.8101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6949FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#876DFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurplePaperIcon);
export default __webpack_public_path__ + "static/media/PurplePaperIcon.283ed4ecccb805117662741f0c928350.svg";
export { ForwardRef as ReactComponent };